import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=c5501142&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=c5501142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5501142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5501142')) {
      api.createRecord('c5501142', component.options)
    } else {
      api.reload('c5501142', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=c5501142&scoped=true&", function () {
      api.rerender('c5501142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4TWBw0fvk4dfd/JS/comp/PopupBox.vue"
export default component.exports